"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConfirmDirectDebitModalWidget = void 0;
var React = require("react");
var plugin_journey_1 = require("@athena-portal/plugin-journey");
var journey_model_1 = require("@athena-portal/journey-model");
var reactstrap_1 = require("reactstrap");
var journey_services_1 = require("@athena-portal/journey-services");
var react_router_dom_1 = require("react-router-dom");
var ConfirmDirectDebitModalWidget = exports.ConfirmDirectDebitModalWidget = /** @class */ (function (_super) {
    __extends(ConfirmDirectDebitModalWidget, _super);
    function ConfirmDirectDebitModalWidget(props) {
        var _this = _super.call(this, props) || this;
        _this.toggle = function () {
            _this.setState(function (state) { return ({
                modalOpened: !state.modalOpened
            }); });
            _this.executeEvent("blur");
        };
        _this.toggleAndRemoveFlag = function () {
            journey_services_1.ObjectManipulator.setField(_this.props.question.interactionField, _this.props.interaction, "false");
            _this.setState(function (state) { return ({
                modalOpened: !state.modalOpened
            }); });
            _this.executeEvent("blur");
        };
        _this.state = {
            modalOpened: true
        };
        _this.toggle = _this.toggle.bind(_this);
        return _this;
    }
    ConfirmDirectDebitModalWidget.prototype.render = function () {
        var isAccountDetailsSet = this.isAccountDetailsSet();
        return (React.createElement(React.Fragment, null, isAccountDetailsSet ? this.renderPositiveModal() : this.renderNegativeModal()));
    };
    ConfirmDirectDebitModalWidget.prototype.renderPositiveModal = function () {
        var closeBtn = React.createElement("button", { className: "btn-close", onClick: this.toggleAndRemoveFlag });
        var interaction = this.props.engine.getInteraction();
        return (React.createElement(reactstrap_1.Modal, { className: "my-2 info-modal", isOpen: this.state.modalOpened, toggle: this.toggleAndRemoveFlag },
            React.createElement(reactstrap_1.ModalHeader, { toggle: this.toggleAndRemoveFlag, close: closeBtn },
                React.createElement("div", { className: "d-flex" },
                    React.createElement("img", { className: "d-block mr-3 mb-1 info-button-width", src: "/img/Flow-info-selected.svg" }),
                    React.createElement("div", { className: "text-blue-2 font-weight-medium" }, "Please confirm your bank account details are correct"))),
            React.createElement(reactstrap_1.ModalBody, { className: "pt-0" },
                React.createElement("p", { className: "mb-0" },
                    "Name of account holder: ",
                    React.createElement("span", { className: "font-weight-bold" }, interaction.paymentDetails.directDebitDetails.accountHolderName)),
                React.createElement("p", { className: "mb-0" },
                    "Account number: ",
                    React.createElement("span", { className: "font-weight-bold" }, interaction.paymentDetails.directDebitDetails.accountNumber)),
                React.createElement("p", { className: "mb-0" },
                    "Sort code: ",
                    React.createElement("span", { className: "font-weight-bold" }, this.formatSortCode(interaction.paymentDetails.directDebitDetails.sortCode))),
                React.createElement("p", { className: "h4 font-weight-bold" },
                    React.createElement("b", null, "Are the above bank account details correct?"))),
            React.createElement(reactstrap_1.ModalFooter, { className: "d-flex modal-footer shadow-none" },
                React.createElement("div", { className: "row justify-content-center" },
                    React.createElement(react_router_dom_1.Link, { className: "direct-debit-amend-laptop blue-link-underline text-decoration-underline pt-3 mr-4 font-weight-bold", to: "#", onClick: this.toggleAndRemoveFlag }, "No, amend my details"),
                    React.createElement("button", { type: "button", className: "btn btn-primary btn-add width-md-250 mb-1 btn-next-no-arrow", onClick: this.toggle }, "Yes, my details are correct"),
                    React.createElement(react_router_dom_1.Link, { className: "direct-debit-amend-mobile blue-link-underline text-decoration-underline font-weight-bold pt-2 pt-1 pb-1 pl-1 pr-1", to: "#", onClick: this.toggleAndRemoveFlag },
                        React.createElement("b", null, "No, amend my details"))))));
    };
    ConfirmDirectDebitModalWidget.prototype.renderNegativeModal = function () {
        var closeBtn = React.createElement("button", { className: "btn-close", onClick: this.toggleAndRemoveFlag });
        return (React.createElement(reactstrap_1.Modal, { className: "my-2 info-modal", isOpen: this.state.modalOpened, toggle: this.toggleAndRemoveFlag },
            React.createElement(reactstrap_1.ModalHeader, { toggle: this.toggleAndRemoveFlag, close: closeBtn },
                React.createElement("div", { className: "d-flex" },
                    React.createElement("img", { className: "d-block mr-3 mb-1 info-button-width", src: "/img/Flow-info-selected.svg" }),
                    React.createElement("div", { className: "text-blue-2 font-weight-medium" }, "Please check your bank account details"))),
            React.createElement(reactstrap_1.ModalBody, { className: "pt-0 font-weight-bold" },
                React.createElement("p", null, "The bank account details you've entered are incomplete or incorrect. Please check them and try again.")),
            React.createElement(reactstrap_1.ModalFooter, { className: "d-flex flex-column modal-footer align-self-end shadow-none" },
                React.createElement("button", { type: "button", className: "btn btn-primary btn-add width-md-250 mb-1 btn-next-no-arrow", onClick: this.toggleAndRemoveFlag }, "Ok, I understand"))));
    };
    ConfirmDirectDebitModalWidget.prototype.isAccountDetailsSet = function () {
        var directDebitDetails = this.props.engine.getInteraction().paymentDetails.directDebitDetails;
        return (directDebitDetails.accountHolderName && directDebitDetails.accountHolderName.length > 0)
            && (directDebitDetails.accountNumber && directDebitDetails.accountNumber.length == 8)
            && (directDebitDetails.sortCode && directDebitDetails.sortCode.length == 6);
    };
    ConfirmDirectDebitModalWidget.prototype.formatSortCode = function (sortCode) {
        return sortCode.slice(0, 2) + "-" + sortCode.slice(2, 4) + "-" + sortCode.slice(4);
    };
    ConfirmDirectDebitModalWidget = __decorate([
        (0, journey_model_1.event)(journey_model_1.Event.onClick),
        __metadata("design:paramtypes", [Object])
    ], ConfirmDirectDebitModalWidget);
    return ConfirmDirectDebitModalWidget;
}(plugin_journey_1.WidgetBase));
//# sourceMappingURL=ConfirmDirectDebitModalWidget.js.map


//////////////////
// WEBPACK FOOTER
// ../falcon-plugins/plugin-falcon-journey/dist/widgets/directDebit/ConfirmDirectDebitModalWidget.js
// module id = 3489
// module chunks = 0